import _argument from "./lib/argument.js";
import _command from "./lib/command.js";
import _error from "./lib/error.js";
import _help from "./lib/help.js";
import _option from "./lib/option.js";
var exports = {};
const {
  Argument
} = _argument;
const {
  Command
} = _command;
const {
  CommanderError,
  InvalidArgumentError
} = _error;
const {
  Help
} = _help;
const {
  Option
} = _option;

// @ts-check

/**
 * Expose the root command.
 */

exports = exports = new Command();
exports.program = exports; // More explicit access to global command.
// Implicit export of createArgument, createCommand, and createOption.

/**
 * Expose classes
 */

exports.Argument = Argument;
exports.Command = Command;
exports.CommanderError = CommanderError;
exports.Help = Help;
exports.InvalidArgumentError = InvalidArgumentError;
exports.InvalidOptionArgumentError = InvalidArgumentError; // Deprecated
exports.Option = Option;
export default exports;
export const program = exports.program,
  InvalidOptionArgumentError = exports.InvalidOptionArgumentError;
const _Argument = exports.Argument,
  _Command = exports.Command,
  _CommanderError = exports.CommanderError,
  _Help = exports.Help,
  _InvalidArgumentError = exports.InvalidArgumentError,
  _Option = exports.Option;
export { _Argument as Argument, _Command as Command, _CommanderError as CommanderError, _Help as Help, _InvalidArgumentError as InvalidArgumentError, _Option as Option };